import styled from "styled-components";
import theme from "../../../../styles/theme";

interface LeftHalfProps {
  leftColor: string;
}

export const LeftHalf = styled.div<LeftHalfProps>`
  position: absolute;
  z-index: 10;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.leftColor};
  clip-path: polygon(0 0, 120% 0, 0 120%);
`;

interface CardProps {
  borderCustomer: boolean;
  colorTitle: string;
  colorBody: string;
  backGroundColor: string;
}
interface BackGroundLupaImgProps {
  backgroundImage: string;
}
export const BackGroundLupaImg = styled.div<BackGroundLupaImgProps>`
  position: absolute;
  left: 40px;
  bottom: 0;
  z-index: 20;
  height: 70%;
  width: 50%;
  background-image: url(${(props) => props.backgroundImage});
  background-size: cover;
`;

export const Card = styled.div<CardProps>`
  h1,
  p,
  span {
    font-family: ${theme.fonts.secondary};
    -webkit-font-smoothing: antialiased; /* Chrome, Safari */
    -moz-osx-font-smoothing: grayscale; /* Firefox no macOS */
    font-smooth: always;
    image-rendering: -webkit-optimize-contrast;
    font-weight: 900;
  }

  h1 {
    color: ${(props) => props.colorTitle};
  }

  p,
  span {
    color: ${(props) => props.colorBody};
    margin-top: 10px;
  }

  text-align: center;
  background-color: ${(props) => props.backGroundColor};

  position: relative;
  border-radius: 20px;
  overflow: hidden;
  border: ${(props) => (props.borderCustomer ? "solid 2px #b09151" : "")};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 2vh;
  align-items: center;

  .lbl {
    font-size: ${theme.fontSize.md};
    font-family: sans-serif;
    @media ${theme.devices.tablet} {
      margin-top: 42px;
    }
  }
`;
